export { default } from './Wave';
export type { Props } from './Wave';
